import autosize from 'autosize';

import './scripts/main';
import { setupForm } from './scripts/forms';

$(document).ready(() => {
  autosize($('#audit-message'));
});

const $auditForm = $('#audit-form');
setupForm($auditForm, $auditForm.siblings('.thank-you-overlay'));
